import * as DSAssetFamilies from 'customer-data-filters-ui/filterQueryFormat/DSAssetFamilies/DSAssetFamilies';
import * as Operators from 'customer-data-filters-ui/filterQueryFormat/operator/Operators';
import { fromJS, OrderedSet, Map as ImmutableMap } from 'immutable';
import FilterOperatorTeamInput from 'customer-data-filters-ui/components/operator/FilterOperatorTeamInput';
import DisplayValueTeam from 'customer-data-filters-ui/components/display/DisplayValueTeam';
import FilterOperatorMultiStringInput from 'customer-data-filters-ui/components/operator/FilterOperatorMultiStringInput';
import { ENUMERATION } from 'customer-data-objects/property/PropertyTypes';
import makeCurrencyField from './makeCurrencyField';
import FilterOperatorOwnerInput from 'customer-data-filters-ui/components/operator/FilterOperatorOwnerInput';
import { EVENT_BASED_FIELD_KEYS } from 'customer-data-filters-ui/strategy/eventBasedFilters';
const fieldDefinitionsByFilterFamily = {
  [DSAssetFamilies.COMPANY_PROPERTY]: {
    hs_parent_company_id: {
      inputType: ENUMERATION
    }
  },
  [DSAssetFamilies.CONTACT_PROPERTY]: {
    associatedcompanyid: {
      inputType: ENUMERATION,
      // https://git.hubteam.com/HubSpot/customer-data-filters-ui/LibraryCopy/pull/354
      operators: OrderedSet.of(Operators.Equal, Operators.NotEqual, Operators.Known, Operators.NotKnown, Operators.EverEqual, Operators.NeverEqual)
    }
  },
  [DSAssetFamilies.DEAL_PROPERTY]: {
    deal_currency_code: makeCurrencyField()
  },
  [DSAssetFamilies.LINE_ITEM_PROPERTY]: {
    hs_line_item_currency_code: makeCurrencyField()
  },
  [DSAssetFamilies.ENGAGEMENT_PROPERTY]: {
    hs_at_mentioned_owner_ids: {
      InputComponent: FilterOperatorOwnerInput
    },
    hs_attachment_ids: {
      InputComponent: FilterOperatorMultiStringInput
    }
  },
  [DSAssetFamilies.FORM]: {
    [EVENT_BASED_FIELD_KEYS.EVENT_SUBJECT]: {
      operators: OrderedSet.of(Operators.Equal)
    },
    [EVENT_BASED_FIELD_KEYS.EVENT_SUBJECT_VERSION]: {
      operators: OrderedSet.of(Operators.Equal)
    },
    [EVENT_BASED_FIELD_KEYS.EVENT_PAGE]: {
      operators: OrderedSet.of(Operators.Equal)
    }
  },
  [DSAssetFamilies.EMAIL_CAMPAIGN]: {
    [EVENT_BASED_FIELD_KEYS.EVENT_SUBJECT]: {
      operators: OrderedSet.of(Operators.Equal)
    },
    [EVENT_BASED_FIELD_KEYS.EVENT_SUBJECT_VERSION]: {
      operators: OrderedSet.of(Operators.Equal)
    },
    [EVENT_BASED_FIELD_KEYS.EVENT_PAGE]: {
      operators: OrderedSet.of(Operators.Equal)
    }
  },
  [DSAssetFamilies.EMAIL_SUBSCRIPTION]: {
    [EVENT_BASED_FIELD_KEYS.EVENT_SUBJECT]: {
      operators: OrderedSet.of(Operators.Equal)
    },
    [EVENT_BASED_FIELD_KEYS.EVENT_SUBJECT_VERSION]: {
      operators: OrderedSet.of(Operators.Equal)
    },
    [EVENT_BASED_FIELD_KEYS.EVENT_PAGE]: {
      operators: OrderedSet.of(Operators.Equal)
    }
  },
  [DSAssetFamilies.CTA]: {
    [EVENT_BASED_FIELD_KEYS.EVENT_SUBJECT]: {
      operators: OrderedSet.of(Operators.Equal)
    },
    [EVENT_BASED_FIELD_KEYS.EVENT_SUBJECT_VERSION]: {
      operators: OrderedSet.of(Operators.Equal)
    },
    [EVENT_BASED_FIELD_KEYS.EVENT_PAGE]: {
      operators: OrderedSet.of(Operators.Equal)
    }
  },
  [DSAssetFamilies.EVENT]: {
    [EVENT_BASED_FIELD_KEYS.EVENT_SUBJECT]: {
      operators: OrderedSet.of(Operators.Equal)
    },
    [EVENT_BASED_FIELD_KEYS.EVENT_SUBJECT_VERSION]: {
      operators: OrderedSet.of(Operators.Equal)
    },
    [EVENT_BASED_FIELD_KEYS.EVENT_PAGE]: {
      operators: OrderedSet.of(Operators.Equal)
    }
  },
  [DSAssetFamilies.LEAD_PROPERTY]: {
    hubspot_owner_id: {
      inputType: ENUMERATION,
      referencedObjectType: 'OWNER'
    }
  }
};
const fieldDefinitionsForAllObjects = {
  hs_all_accessible_team_ids: {
    operators: OrderedSet.of(Operators.ContainAllTeams),
    InputComponent: FilterOperatorTeamInput,
    ValueComponent: DisplayValueTeam
  },
  hs_merged_object_ids: {
    operators: OrderedSet.of(Operators.EqualAny, Operators.NotEqualAny, Operators.Known, Operators.NotKnown, Operators.UpdatedInLastXDays, Operators.NotUpdatedInLastXDays, Operators.UpdatedAfter, Operators.UpdatedBefore),
    InputComponent: FilterOperatorMultiStringInput
  }
};
export const getObjectSegFieldDefinitionsForFilterFamily = filterFamily => {
  if (!filterFamily) {
    return ImmutableMap();
  }
  const fieldDefinitionsForFilterFamily = fieldDefinitionsByFilterFamily[filterFamily] || {};
  return fromJS(Object.assign({}, fieldDefinitionsForAllObjects, fieldDefinitionsForFilterFamily));
};